import create from './create'
import del from './delete'
import edit from './edit'
import exp from './export'
import form from './form'
import xlsxUpload from './xlsx-upload'
import { MR, MRS, ND } from '@/model/salutations'

export default {
    create,
    edit,
    export: exp,
    delete: del,
    form,
    xlsxUpload,

    search: {
        button: 'Search',
        placeholder: 'Search input'
    },
    table: {
        nodata: 'Unfortunately no result...',
        noresults: 'Loading data ...',
        perpage: 'User pro Seite',
        result: '{start} bis {stop} von {total}',
        tooltip: 'Please contact the administrator at trendmanager@trendone.com to edit this user',
        salutation: {
            [MRS]: 'Mrs',
            [MR]: 'Mr',
            [ND]: 'n/d'
        }
    },
    header: {
        email: 'E-Mail',
        salutation: 'Salutation',
        firstName: 'First name',
        lastName: 'Last name',
        company: 'Company',
        role: 'Role',
        state: 'Active?',
        actions: 'Actions',
        locked: 'Locked'
    }
}
